module.exports = __webpack_public_path__ + "static/img/icon_star_eple@2x.3c086d2b.png";